var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"Breadcrumb"}},[_c('ol',[_c('li',[_c('a',{attrs:{"href":"/","title":"Página de inicio del UiKit"}},[_vm._v("Inicio")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Videoatención")])])])])])])
}]

export { render, staticRenderFns }